module.exports = __webpack_public_path__ + "img/1.9cc78802.jpg";